import { z } from "zod";
import { BladeHeaderSchema } from "../../fragments/BladeHeader";
import { BladeCommonSchema } from "../common";
import { BackdropSchema } from "../../fragments/Backdrop";
import { MediaPromoItemSchema } from "../../fragments/MediaPromoItem";
export const MediaPromosListBladeTypeValues = [
    "articleMediaGallery",
    "articlePromoCardGrid",
    "landingPromoCardCarousel",
];
export const MediaPromosListBladeTypesSchema = z.enum(MediaPromosListBladeTypeValues);
export const MediaPromosListBladeTypes = MediaPromosListBladeTypesSchema.enum;
export const MediaPromosListBladeSchema = BladeCommonSchema.extend({
    backdrop: BackdropSchema.optional(),
    header: BladeHeaderSchema.optional(),
    items: z.array(MediaPromoItemSchema).nonempty(),
});
export const MediaPromosListBladesContractSchema = MediaPromosListBladeSchema.extend({
    type: MediaPromosListBladeTypesSchema,
});
export const ArticleMediaGalleryContractSchema = MediaPromosListBladeSchema.extend({
    type: z.literal(MediaPromosListBladeTypes.articleMediaGallery),
});
export const ArticlePromoCardGridContractSchema = MediaPromosListBladeSchema.extend({
    type: z.literal(MediaPromosListBladeTypes.articlePromoCardGrid),
});
export const LandingPromoCardCarouselContractSchema = MediaPromosListBladeSchema.extend({
    type: z.literal(MediaPromosListBladeTypes.landingPromoCardCarousel),
});
export const transformMediaPromosItemsToGroups = (items) => {
    return items.map((item) => ({
        label: "",
        thumbnail: item.media,
        content: { ...item },
    }));
};
//# sourceMappingURL=index.js.map